import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function BucketIcon(props) {
  return (
    <SvgIcon viewBox='0 0 24 24' {...props} >
      <path d="M7 2v11h3v9l7-12h-4l4-8z"/>
    </SvgIcon>
  );
}
